partner-appconfig-categories